import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { SelectInput, useGetList } from "react-admin";

const PORTS_PAGINATION = { page: 1, perPage: 25 };
const PORTS_SORT = { field: "id", order: "DESC" };

const useStyles = makeStyles({
	list: {
		"& > .Mui-disabled": {
			opacity: 0.7,
			backgroundColor: "rgba(255,0,0,0.5)",
		},
	},
});

export const PortSelectInput = ({ terminalId, filter, disableValue, ...props }) => {
	const classes = useStyles();
	const portsFilter = {
		...filter,
		...(terminalId ? { terminal_id: [terminalId] } : {}),
		is_deleted: false,
		no_range: true,
	};
	const { data, ids } = useGetList("ports", PORTS_PAGINATION, PORTS_SORT, portsFilter);
	const choices = (ids || []).map((id) => data[id]).filter(Boolean);

	return (
		<SelectInput
			SelectProps={{ MenuProps: { classes: classes } }}
			allowEmpty
			emptyValue=""
			optionText="name"
			disableValue={disableValue ?? "disabled_by_any"}
			{...props}
			choices={choices}
		/>
	);
};
